import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { ForwardRefForwardPropsComponent } from '@pega/cosmos-react-core';

import type { FeedContentProps } from './Feed.types';
import FeedRichTextViewer from './FeedRichTextViewer';

const FeedContent: ForwardRefForwardPropsComponent<FeedContentProps> = forwardRef(
  function FeedContent(
    { children, onLinkRender, ...restProps }: PropsWithoutRef<FeedContentProps>,
    ref: FeedContentProps['ref']
  ) {
    return typeof children === 'string' ? (
      <FeedRichTextViewer {...restProps} ref={ref} content={children} onLinkRender={onLinkRender} />
    ) : (
      children
    );
  }
);

export default FeedContent;
